// const baseSize = 0.8
function setRem(){
    // const scale = document.documentElement.clientWidth / 1920
    // document.documentElement.style.fontSize = baseSize * Math.min(scale, 2) + "px"
    let html = document.getElementsByTagName("html")[0];
    if (window.innerWidth * window.innerHeight <= 1920 * 1080) {
        html.style.fontSize = (window.innerWidth * window.innerHeight) / 1920 / 1080 + "px";
    } else {
        html.style.fontSize = (window.innerWidth * window.innerHeight) / 1920 / 1080 / 2 + "px";
    }
}
setRem()

window.addEventListener('resize', setRem, false)
window.onresize = function(){
    setRem()
}